<template>
		<div class="form-group" v-if="classLevel === 'Bercario' || classLevel === 'Infantil' || classLevel === 'Fundamental_1'">
			<h5 v-translate>O aluno compareceu na escola hoje?</h5>
			<div>
				<label class="mt-radio mt-radio-outline" v-for="(value, key) in presence">
					<input type="radio" name="presence" :value="key" :checked="key === stdPresence" @change="putAgendaPresence">{{ value }}
					<span></span>
				</label>
			</div>
		</div>

</template>

<script>
	import StudentPresence from './student-presence';
	export default StudentPresence;
</script>

<style lang="scss" scoped>
	.mt-radio-outline{
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// StudentPresence.vue?52ef8c03